module.exports = { "default": require("core-js/library/fn/array/from"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-bootstrap/node_modules/babel-runtime/core-js/array/from.js
// module id = 1090
// module chunks = 1 2 3